import React from 'react'

import clsx from 'clsx'

import Typography from 'components/Typography'

import styles from './DisplayLabel.module.scss'

/** @type {import("./types").default} */
const DisplayLabel = ({ label, variant = 'large' }) => {
  return (
    <Typography
      className={clsx('DisplayLabel', styles.root)}
      variant={variant === 'large' ? 'heading-sm' : 'heading-xs'}
    >
      {label}
    </Typography>
  )
}

export default DisplayLabel
